import { Injectable } from '@angular/core';
import { EmailBase } from './ecom-useremailbase';
import { PaymentBase } from './ecom-storepaymentbase';
import { StoreCartBase } from './ecom-storecartbase';
import { PaxDetails } from './ecom-pax-details-base';

@Injectable()
export class StoreServiceBase {
    serviceGuid = ' ';
    serviceType = ' ';
    serviceDatetime = '';
    serviceEstimatedDatetime: Date;
    servicepax = 0;
    serviceStatus = ' ';
    serviceRemarks = ' ';
    serviceLocationGuid = ' ';
    locationPkid = 0;
    serviceLocationName = ' ';
    serviceLocationAddress = '';
    serviceCompanyGuid = ' ';
    serviceCompanyName = ' ';
    serviceLocationAreaId = ' ';
    serviceLocationAreaName = ' ';
    serviceLocationTableId = ' ';
    serviceLocationTableName = '';
    serviceCompanyId = ' ';
    serviceEmail: EmailBase;
    servicePayment: PaymentBase;
    storeCart: StoreCartBase = new StoreCartBase();
    serviceCompleted = false;
    serviceActiveId = 0;
    serviceLocationContact = '';
    serviceAddressLandmark = '';
    serviceAddressURL = '';
    serviceLatLang = '';
    servicePlaceId = '';
    serviceQRScanned = false;
    serviceUsername = '';
    serviceUserDialCode = '';
    serviceUserMobilenumber = '';
    serviceUserEmail = '';
    serviceListPaxDetails: PaxDetails[] = [];
    selectedDate = '';
    selectedTime = '';
    userConfirmedChange = false;

    constructor(data?: Partial<StoreServiceBase>) {
        Object.assign(this, data);

    }
}
